// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { star8Point16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-star-8-point': IconStar8Point;
    }
}

/**
 * The icon component for the 'star8Point' icon
 */
export class IconStar8Point extends IconSvg {
    public constructor() {
        super(star8Point16X16);
    }
}

registerIconSvg('icon-star-8-point', IconStar8Point);
export const iconStar8PointTag = 'nimble-icon-star-8-point';
